"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../../schema");
const value = schema_1.Schema.number()
    .expiration(15552000)
    .unit("mmol/L")
    .precision(2)
    .min(1)
    .max(100)
    .interpretation({ vocab: "ltx", code: "karbamid" })
    .tag({ vocab: "snomed", code: "105011006" })
    .tag({ vocab: "loinc", code: "14937-7" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "396550006" })
    .tag({ vocab: "snomed", code: "44277000" })
    .tag({ vocab: "loinc", code: "24362-6" });
